<template>
    <div>
        <h1>page main Keep alive</h1>
        <keep-alive>
            <router-view :key="$route.fullPath"></router-view>
        </keep-alive>
    </div>
</template>
<script>
export default {
    name: "PageMain",
}
</script>
